var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRollershutters = function SvgRollershutters(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 413,
    height: 413,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 413 413",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1",
    fill: "currentColor",
    d: "M27.01 39.48H387c6.49 0 11.8 5.31 11.8 11.8v44.05c0 6.49-5.31 11.8-11.8 11.8H27.01c-6.48 0-11.8-5.31-11.8-11.8V51.28c0-6.49 5.31-11.8 11.8-11.8m23.45 75.73h24.98v226.35H50.46zm286.8 0h24.97v226.35h-24.97zM26 350.79h360.69c6.87 0 12.49 5.62 12.49 12.49 0 6.86-5.62 12.49-12.49 12.49H26c-6.87 0-12.49-5.62-12.49-12.49s5.62-12.49 12.49-12.49m87.42-206.06h185.33c6.87 0 12.49 5.62 12.49 12.49s-5.62 12.49-12.49 12.49H113.42c-6.87 0-12.49-5.62-12.49-12.49s5.62-12.49 12.49-12.49m0 47.35h185.33c6.87 0 12.49 5.62 12.49 12.49s-5.62 12.49-12.49 12.49H113.42c-6.87 0-12.49-5.62-12.49-12.49s5.62-12.49 12.49-12.49m0 48.39h185.33c6.87 0 12.49 5.62 12.49 12.49s-5.62 12.49-12.49 12.49H113.42c-6.87 0-12.49-5.62-12.49-12.49s5.62-12.49 12.49-12.49m0 47.88h185.33c6.87 0 12.49 5.62 12.49 12.49 0 6.86-5.62 12.48-12.49 12.48H113.42c-6.87 0-12.49-5.61-12.49-12.48s5.62-12.49 12.49-12.49"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRollershutters);
export default ForwardRef;